import React from 'react';
import CaseStudyTemplate, {
  CaseStudySection,
  GraphicPlaceholder,
  StoryParagraph,
} from './CaseStudyTemplate';

const PersonalPortfolioCaseStudy = () => (
  <CaseStudyTemplate
    title="Designing and coding this portfolio as a product"
    intro="I approached my portfolio like a real product: clear positioning up front, intentional narrative depth, and an interaction system that feels coherent from homepage to case study details."
    details={[
      { label: 'Type', value: 'Design + engineering' },
      { label: 'Timeline', value: '2026 to present' },
      { label: 'Stack', value: 'React, styled-components, Framer Motion' },
      { label: 'Goal', value: 'Recruiter clarity and storytelling depth' },
    ]}
    sectionNav={[
      { id: 'overview', label: 'Overview' },
      { id: 'architecture', label: 'Architecture' },
      { id: 'features', label: 'Features' },
      { id: 'notes', label: 'Notes' },
    ]}
    backTarget="selected-work"
  >
    <CaseStudySection id="overview" title="Overview">
      <StoryParagraph>
        Most portfolio sites either over-index on visuals with weak substance, or over-index on text with weak scanability. I wanted both: immediate confidence and deliberate depth.
      </StoryParagraph>
    </CaseStudySection>
    <CaseStudySection id="architecture" title="Architecture">
      <StoryParagraph>
        I built a reusable system of section rhythms, typography, and route behaviors so new projects can be added without reinventing layout decisions.
      </StoryParagraph>
      <GraphicPlaceholder
        title="Graphic placeholder: information architecture"
        note="Map homepage entry points to project pages and show shared narrative structure."
      />
    </CaseStudySection>
    <CaseStudySection id="features" title="Features">
      <StoryParagraph>
        Key moments include scroll-aware navigation, section reveal motion, and back-navigation that restores context after reading a case study.
      </StoryParagraph>
    </CaseStudySection>
    <CaseStudySection id="notes" title="Notes">
      <StoryParagraph>
        The meta goal was design integrity: every page should feel authored by the same person, with the same point of view, not assembled from disconnected templates.
      </StoryParagraph>
    </CaseStudySection>
  </CaseStudyTemplate>
);

export default PersonalPortfolioCaseStudy;
